import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-1 pb-8 pt-3 lg:px-8 xl:flex-row">
      <h5 className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
        <p className="mb-4 text-center text-sm text-gray-600 sm:!mb-0 md:text-base">
          AlphaSniperLLC © All Rights Reserved
        </p>
      </h5>
      <div>
        <ul className="flex flex-wrap items-center gap-3 sm:flex-nowrap md:gap-10">
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:support@alphasniper.io"
              className="text-base font-medium text-gray-600 hover:text-gray-600"
            >
              Support
            </a>
          </li>
          <li>
            <Link
              to="/TermsAndConditions"
              className="text-base font-medium text-gray-600 hover:text-gray-600"
            >
              Terms
            </Link>
          </li>
          <li>
            <Link
              to="/PrivacyPolicy"
              className="text-base font-medium text-gray-600 hover:text-gray-600"
            >
              Privacy
            </Link>
          </li>
          <li>
            <Link
              to="/FrequentlyAskedQuestions"
              className="text-base font-medium text-gray-600 hover:text-gray-600"
            >
              FAQ
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
